module.exports = __webpack_public_path__ + "static/media/link.d54a236b.svg";